import graphql from "babel-plugin-relay/macro";
import styled from "styled-components";
import InspectionReportCard from "./InspectionReportCard";
import { useState } from "react";
import Button from "./Buttons/Button";
import { useFragment } from "react-relay";
import { InspectionReportOverview$key } from "./__generated__/InspectionReportOverview.graphql";

const MAX_INSPECTION_REPORTS = 3;

const InspectionReportOverview = ({
  inspectionField,
}: {
  inspectionField: InspectionReportOverview$key;
}) => {
  const [showAll, setShowAll] = useState<boolean>(false);
  const data = useFragment(
    graphql`
      fragment InspectionReportOverview on InspectionfieldNode {
        inspections {
          edges {
            node {
              id
              approvedDate
              rejectedDate
              retryDate
              ...InspectionReportCard
              state
            }
          }
        }
      }
    `,
    inspectionField
  );
  return (
    <Container>
      <Title>Overzicht schouwrapporten</Title>
      {data?.inspections?.edges
        .filter((edge) =>
          ["APPROVED", "REJECTED", "RETRY"]?.includes(edge?.node?.state || "")
        )
        .sort((edgea, edgeb) =>
          new Date(
            edgea?.node?.approvedDate ||
              edgea?.node?.rejectedDate ||
              edgea?.node?.retryDate ||
              undefined
          ) >
          new Date(
            edgeb?.node?.approvedDate ||
              edgeb?.node?.rejectedDate ||
              edgeb?.node?.retryDate ||
              undefined
          )
            ? -1
            : 1
        )
        ?.map((edge) =>
          edge?.node ? (
            <InspectionReportCard
              key={edge?.node?.id}
              inspection={edge?.node}
            />
          ) : null
        )
        .slice(0, showAll ? Number.POSITIVE_INFINITY : MAX_INSPECTION_REPORTS)}
      {data?.inspections?.edges?.length > MAX_INSPECTION_REPORTS && (
        <ButtonContainer>
          <Button
            label={showAll ? "Toon minder" : "Toon meer"}
            onClick={() => setShowAll(!showAll)}
          />
        </ButtonContainer>
      )}
    </Container>
  );
};

export default InspectionReportOverview;

const Title = styled.h3`
  color: var(--donkergrijs, #212529);
  /* Tablet/H3 */
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */
`;

const Container = styled.div`
  h3 {
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-bottom: 12px;
`;

const ButtonContainer = styled.div`
  width: 180px;
  margin: 0 auto;
  padding: 12px;
`;
